import React from 'react';
import { useTranslation } from 'react-i18next'; // For language handling
import { Link } from 'react-router-dom'; // Import Link from react-router-dom


import KSAGEOID21 from '../assets/images/KSA-GEOID21.png';//KSA-GEOID21.png



function KSAGEOID17() {
  const { t } = useTranslation(); // Hook for translation

  return (
    <div >
    {/* Hero Section */}
    <div className="hero-banner">
      <div className="hero-content" >
        <h1 style={{ color: 'black' }}>{t('KSA_Geoid')}</h1>
        
      </div>
      
    </div>
    
    

    {/* Content Section */}
    <div className="hero-banner" style={{ backgroundColor: 'white' }}>
        <div className="hero-content">
          <p style={{ textAlign: 'justify' }}>{t('KSA_GEOD17_sub1')}
          </p>
          <p style={{ textAlign: 'justify' }}>{t('KSA_GEOD17_sub2')}</p>
          <p style={{ textAlign: 'justify' }}>{t('KSA_GEOD17_sub3')}</p>
          <p style={{ textAlign: 'justify' }}>{t('KSA_GEOD17_sub4')}</p>
          <p style={{ textAlign: 'justify' }}>{t('KSA_GEOD17_sub5')} 
          <a href={t('SANSRS_Technical_Summary_URL')} download> 
                  {t('sansrs_def1_sub6_link')}
                </a>
            </p>
          <br />  
          
          <img src={KSAGEOID21} alt="Arrow Icon" style={{ width: '100%', height: 'auto', maxWidth: '600px' }} />
          </div>
          <br />  
         

          
      </div>
      <div className="cards-space" style={{height:"40px"}}></div>
      
      
 
    <section class="services"style={{gap:"6rem", padding:"1rem"}}>
    <p style={{ textAlign: 'justify' }}>{t('tools')}
    <ul> 
    <li><Link to="https://gds.geoportal.sa/VRF" target='balnk'>{t('KSA_GEOD17_tool')}</Link></li>
    <li><Link to="https://gds.geoportal.sa/geoidcalculator" target='balnk'>{t('KSA_GEOD17_tool2')}</Link></li>
        </ul><Link to="/Geodesy/Sansrs/KSAGEOID17/FAQ">{t('faq_title')}</Link></p>
      
    </section>
    </div>
);
}

export default KSAGEOID17;
